import { create } from 'zustand';
import { getKconfDataV2 } from '@/common/kconf';

export interface IKconfState {
    // kconf是否在加载中
    loading: boolean;
    // 保存加载的结果
    setLoadResult: (result: Map<string, any>) => void;
    // kconf加载结果的对象key，没有泛型约束
    [key: string]: any;
}

// 全局的kconf Store
export const useKconfStore = create<IKconfState>(set => ({
    // 是否ab获取中
    loading: true,
    setLoadResult: result => set(Object.assign({}, { loading: false }, result)),
}));

// 初始化全局的kconf
function initGlobalKconf() {
    const kconfKeys = [
        // 开关打开，允许用户从购物车凑单半屏直接去提单
        'kibtFrontend.webConfig.shop_c_myshoppingcar_shippingmakeup2_switch',
        'kibtFrontend.e-commerce.AddOnPopupCount',
        'kibtFrontend.webConfig.shop_c_shoppingcar_border',
        'kibtFrontend.webConfig.shop_c_orderconfirm_notice',
        'kibtFrontend.webConfig.shop_c_orderdetail_notice',
        'kibtFrontend.webConfig.shop_c_orderconfirm_subsidy_freq',
    ];

    const fetchkconfData = async () => {
        // 接口获取并缓存
        try {
            const res = await getKconfDataV2(kconfKeys);
            return res;
        } catch (e) {
            return {};
        }
    };

    fetchkconfData().then(res => {
        useKconfStore.getState().setLoadResult(res);
    });
}

initGlobalKconf();
